import Vue from 'vue'
/* eslint-disable import/prefer-default-export */

export const vuexPushArrayToStore = (state, stateArrayName, newArray, key = 'id') =>
{
    if(!newArray) return;

    const indexName = stateArrayName + 'Index'
    if(!state[indexName]) state[indexName] = {}
    const stateIndexArray = state[indexName]
    const stateArray = state[stateArrayName];

    if(stateArray.length){
        const l = newArray.length;
        const ll = stateArray.length;

        for (let i = 0; i < l; i++) {
            const newItem = newArray[i]

            if( stateIndexArray[ newItem[ key ] ] !== undefined ){
                Vue.set( stateArray, stateIndexArray[ newItem[ key ] ], newItem)
            }
            else {
                stateArray.push(newItem)
                stateIndexArray[ newItem[ key ] ] += ll
            }
        }
    }
    else{
        stateArray.push(...newArray)
        stateArray.forEach( (item, index) => { stateIndexArray[item.id] = index } )
    }
}
